import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { AttachmentContainer } from './styled'
import { FileUploadCell } from 'components'

// import r from 'reactotron-react-js'

const AttachmentInformation = (props) => {
  const { valueForm, change, isDisplay = false, showCollapse = true } = props
  const [showAttachmentInfo, setShowAttachInfo] = useState(true)

  useEffect(() => {
  }, [])

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Attachments'
        action={
          showCollapse ?
            <IconButton aria-label='Expand' onClick={() => setShowAttachInfo(!showAttachmentInfo) }>
              {showAttachmentInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton> : null
        }
      />
      <Collapse in={showAttachmentInfo}>
        <CardContent>
          <AttachmentContainer>
            {
              editableForm() ? 
                <Field 
                  name='SL01' 
                  label=''
                  type={type.file}
                  oldFiles={valueForm.attachment01 || []}
                  showOldFile
                  removeOldFiles={(index, code) => { 
                    var clone = [...valueForm.attachment01]
                    clone.splice(index, 1)
                    change('attachment01', [...clone])
                  }}
                  component={FieldInput} /> : 
                <div>
                  {
                    (valueForm.attachment01 || []).map(a =>
                      <FileUploadCell 
                        key={a.name}
                        fileName={a.originalFilename}
                        fileSize={a.size}
                        urlPath={a.urlPath||null} 
                        deletable={false}
                      />
                    )
                  }
                </div>
            }
            
          </AttachmentContainer>
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({

  })
}
  

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentInformation)